module.exports = __webpack_public_path__ + "img/radiometro-infrarrojo.1c9ff4d3.webp";